import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as XLSX from 'xlsx';

type AOA = any[][];

// interface's
interface steptype {
  id: Number;
  title: String;
  warring: String;
  des: String;
  link: Boolean;
  status: Number;
}

@Component({
  selector: 'app-import-dropoff-locations-dialog',
  templateUrl: './import-dropoff-locations-dialog.component.html',
  styleUrls: ['./import-dropoff-locations-dialog.component.scss'],
})
export class ImportDropoffLocationsDialogComponent implements OnInit {
  stepData: steptype[] = [
    {
      id: 1,
      title: 'Upload your file',
      des: 'Choose the file that contains your drop-off addresses for upload. Click on the "Download Sample File" link to see an example file. Your CSV should include the following columns: customer Name, Country Code, Mobile Number, Package Contents, Package Size (kg), Cash Collection (leave blank if not needed), and Drop-off Location.',
      warring: '',
      link: true,
      status: 1, // 1 is running step 2 upcomming 3 is completed
    },
    {
      id: 2,
      title: 'Review Your File Data',
      des: 'Review the information below to ensure it is correct. If any changes are needed, edit your file and upload it again.',
      warring: '',
      link: true,
      status: 2,
    },
    {
      id: 3,
      title: 'Match Your Data',
      des: ``,
      warring: '',
      link: true,
      status: 2,
    },
  ];

  form: FormGroup;
  data: AOA = [];
  wopts: XLSX.WritingOptions = { bookType: 'xlsx', type: 'array' };
  isSheetValid: boolean;
  mappingTableData = [];
  dataToUpload = [];
  optionForm: FormGroup;
  selectedValue: Number | undefined = 1;

  constructor(
    public _matDialogRef: MatDialogRef<ImportDropoffLocationsDialogComponent>,
    private _fb: FormBuilder,
    private _cd: ChangeDetectorRef,
    private _snackbar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public _data
  ) {
    // CREATE FORM TO UPLOAD FILE
    this.createForm();

    let fields = [];
    this._data.feilds.forEach((field, i) => {
      if (field.isRequired) fields.push(field.title);
    });
    this.stepData[
      this.stepData.length - 1
    ].des = `Select the correct options from the drop downs to match your file's columns with the required fields. The essential fields are <span class="text-rose-500"> ${fields
      .join(', ')
      .toUpperCase()}</span>.`;
  }

  ngOnInit(): void { }

  createForm() {
    this.form = this._fb.group({
      file: ['', Validators.required],
    });
  }

  // DROPPED FILE FUNCTION
  dropped(files) {
    for (const droppedFile of files) {
      if (droppedFile.fileEntry.isFile) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
        fileEntry.file((file: File) => {
          this.onFileChange(file, 'dropped');
        });
      }
    }
  }

  // download Sample File
  downloadSampleFile() {
    if (this._data?.isInterRegional) {
      window.open('../../../assets/example_file/inter-regional-dropoff-locations.xlsx');
    } else {
      window.open('../../../assets/example_file/dropoff-locations.xlsx');
    }
  }

  // ON CALL FILE SELECT
  onFileChange(evt, method?) {
    //on file selection
    const reader: FileReader = new FileReader();
    let fileObj: any;
    if (method == 'dropped') {
      fileObj = evt;
    } else {
      /* wire up file reader */
      const target: DataTransfer = <DataTransfer>evt.target;
      if (target.files.length > 1) {
        // MULTIPLE FILE NOT ALLOWED
        this._snackbar.open('Cannot use multiple files', 'OKAY');
        this.form.get('file').setValue(target.files);
      }
      fileObj = target.files[0];
    }

    // ON REAL FILE
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

      /* grab first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      /* save data */
      this.data = <AOA>XLSX.utils.sheet_to_json(ws, { header: 1 });
      this.data = this.data.filter((element: any) => element.length);

      let maxDataLength = this.data.length;
      let maxItemLength = this.data[0].length;
      let data = this.data;

      this.stepData[0].status = 3;
      this.stepData[1].status = 1;
      this.stepData[2].status = 2;
      console.log("this.stepDatathis.stepData", this.stepData);

      for (let index = 0; index < maxDataLength; index++) {
        if (data[index].length) {
          for (let inx = 0; inx < maxItemLength; inx++) {
            if (data[index][inx] == '') {
              data[index][inx] = '';
            }

            if (data[index][inx] == undefined) {
              data[index][inx] = '';
            }

            if (data[index][inx - 1] == undefined) {
              data[index][inx - 1] = '';
            }
          }
        }
      }

      this.data.forEach((item) => console.log('item after condition', item));

      const validationErrors = this.validateSheetData(this.data);
      if (validationErrors.length > 0) {
        this._snackbar.open(validationErrors[0], 'OKAY', { duration: 5000 });
        this.sheetInvalid();
        return;
      }

      if (this.data?.length) {
        if (this._data.maxIndex < this.data?.length - 1) {
          this._snackbar.open(
            `You are importing ${this.data?.length - 1
            } drop locations at once, but only ${this._data.maxIndex
            } locations can be imported at a time.`,
            'OKAY',
            { duration: 5000 }
          );
          this.sheetInvalid();
        }

        /* add validation for SrNo */
        let srChecker = [];
        let titleChecker = [];
        let firstNameChecker = [];
        let lastNameChecker = [];
        let phoneNumberChecker = [];
        // let emailChecker = [];

        if (
          this.data.length == srChecker.length &&
          this.data.length == titleChecker.length &&
          this.data.length == firstNameChecker.length &&
          this.data.length == lastNameChecker.length &&
          this.data.length == phoneNumberChecker.length &&
          this.data.length
        ) {
          // noting to do.
          // THIS IS PETTERN FOR EMAIL FOTMATE VALIDATION

          this.sheetValid();
        } else {
          // IF SERIAL NUMBER IS NOT VALIDATE.
          // this._snackbar.open('All serial number are not available in the sheet', "OKAY", { duration: 4000 })
          // this.form.get('file').setValue('');
        }
      } else {
        this.data = [];
        this._snackbar.open(
          'Sorry, no data was found on the sheet. Please make another selection.',
          'OKAY'
        );
        this.form.get('file').setValue('');
        this.sheetInvalid();
      }
    };
    reader.readAsBinaryString(fileObj);
  }

  // IF SHEET VALID
  sheetValid() {
    this.isSheetValid = true;
  }

  // IF SHEET INVALID
  sheetInvalid() {
    this.isSheetValid = false;
    this.data = [];
  }

  // ON CALL ON CONFIRM ACTION
  // PROCEED TO STEPS 2
  onConfirmFile() {
    this.stepData[0].status = 3;
    this.stepData[1].status = 3;
    this.stepData[2].status = 1;
    console.log('this.data====>>', this.data);
    this.setDataIntoMappingTabel(this.data);
    const requiredOptionsLength = this.mappingTableData[0].options.filter(
      (field) => field.isRequired
    ).length;
    if (requiredOptionsLength > this.data[0].length) {
      this.stepData[1].warring =
        'Your sheet is missing some required columns. Please adjust your data to match the required fields and try again.';
    }
  }

  /* 
      MAIN FUNCTION FOR SET DATA FOR COLUMNS MAPPING
    */
  setDataIntoMappingTabel(data) {
    this.optionForm = this._fb.group({});
    data.forEach((element, i) => {
      if (i === 0) {
        element.forEach((item) => {
          const dataObject: any = {
            colName: item,
            options: this.createOption(),
            colId: undefined,
            data: [],
            selected: 0,
            option: null,
          };
          this.mappingTableData.push(dataObject);
          this.optionForm.addControl(
            dataObject['colName'],
            new FormControl('')
          );
        });
      }
      if (i !== 0) {
        console.log('this is element', element);
        element.forEach((item, i) => {
          this.mappingTableData[i].data.push(item == '' ? '' : item);
        });
      }
      console.log('this.mappingTableData', this.mappingTableData);
    });

    // setValue for option selected
    this.getSeletedValue();
  }

  // FUNCTION  FOR SET OPTION IN MAPPING DATA OPTION.
  createOption() {
    // ALL OPTION CREATION
    let option: any = [
      {
        id: 0,
        name: 'Do Not Import',
      },
    ];
    // SET API FEILDS DATA INTO OPTIONS
    this._data?.feilds.forEach((item, index) => {
      // console.log("item", item);
      item['isDisable'] = false;
      option.push(item);
    });
    return option;
  }

  getSeletedValue(): void {
    for (const key in this.optionForm.controls) {
      this.mappingTableData.forEach((field, i) => {
        if (
          String(field?.colName).replace(' ', '').toLowerCase() ==
          String(key).replace(' ', '').toLowerCase()
        ) {
          // console.log("field", field);
          field.options.forEach((optionItem) => {
            console.log("optionItem", optionItem);
            if (
              String(optionItem.createField).replace(' ', '').toLowerCase() ==
              String(key).replace(' ', '').toLowerCase()
            ) {
              this.optionForm.get(key).setValue(optionItem.id);
              field.colId = optionItem.id;
              field.option = optionItem;
              field.selected = optionItem.id;
            }
          });

          // if some field are rquired than check all col.
          if (this._data?.for == 'isForOrder') {
            this.checkRequiredFieldEmpty(field);
          }
        }
      });
    }
  }

  // if field is required then check all the col. in the sheet should filled.
  checkRequiredFieldEmpty(field) {
    console.log('this is the field', field);
    if (field?.selected && field?.option?.isRequired && field?.data?.length) {
      if (!field.data.every((item) => item)) {
        const message = this._snackbar.open(
          `The ${field.option.name} is required, and there is some missing data in the '${field.colName}' column of your sheet. Please fill in all the data for this column.`,
          'OKAY'
        );
        message.afterDismissed().subscribe((res) => {
          console.log('res', res.dismissedByAction);
          if (res.dismissedByAction) {
            field['option'] = null;
            field['colId'] = null;
            field['selected'] = null;
            this._cd.detectChanges();
            this.optionForm['controls'][field.colName].setValue('');
          }
        });
      }
    }
  }


  // CALL ON SELECTION CHANGE  
  onChangeColField(event, i, options) {
    let optionIsSelected = false;
    this.mappingTableData.forEach((element) => {
      if (element?.colId) {
        if (element.colId === Number(event.value)) {
          optionIsSelected = true;
        }
      }
    })
    if (!optionIsSelected) {
      this.mappingTableData[i].colId = Number(event.value);
      this.mappingTableData[i].options.forEach((item) => {
        if (item.id == event.value) {
          this.mappingTableData[i].option = item;
          if (this._data?.for == 'isForOrder') {
            this.checkRequiredFieldEmpty(this.mappingTableData[i])
          }
        }
      })
    } else {
      this.mappingTableData[i].colId = null;
      this.mappingTableData[i].option = null;
      this.mappingTableData[i].selected = null;
      this._cd.detectChanges();
      this._snackbar.open(`"${options.filter((item) => item.id === event.value)[0].createField.toUpperCase()}" is already selected in other columns. Please select a different option.`, "OKAY", { duration: 3000 });
      this.optionForm['controls'][this.mappingTableData[i].colName].setValue('');
    }

    // hanle unique id.
    // if duplicate uid availble.
    if (this._data?.for == 'isForOrder') {
      this.handleUniqueIds(this.mappingTableData);
    }

  }

  getProgressValue() {
    console.log("getProgressValue", this.stepData);
    // status: 1, // 1 is running step 2 upcomming 3 is completed
    if (this.stepData[0].status == 3 && this.stepData[1].status == 2 && this.stepData[2].status == 2) {
      return 0
    } else if (this.stepData[0].status == 3 && this.stepData[1].status == 1 && this.stepData[2].status == 2) {
      return 50
    } else if (this.stepData[0].status == 3 && this.stepData[1].status == 3 && this.stepData[2].status == 1) {
      return 100
    } else {
      return 0
    }
  }



  handleUniqueIds(data) {
    const uIdData = data.filter((item) => item.option ? item.option?.id == 1 : null);
    if (uIdData.length) {
      let uid = 0;
      uIdData[0].data.forEach((item) => {
        if (item != uid) {
          uid = item;
        } else {
          this._snackbar.open('Duplicate Unique ID found in your sheet. Please review the sheet data and re-upload it.', 'OKAY', { duration: 3000 })
          this.resetStateData();
        }
      })
    }
  }


  resetStateData() {
    this.stepData[0].status = 1;
    this.stepData[1].status = 2;
    this.stepData[2].status = 2;
    this.stepData[1].warring = '';
    this.mappingTableData = [];
    this.data = undefined;
    this.sheetInvalid();
  }

  formValidator() {
    return this.mappingTableData.filter((el) => (el?.colId && el.option?.isRequired)).length === this._data.feilds.filter((item) => item.isRequired).length && !this.mappingTableData.filter((item) => item.selected === null).length && this.mappingTableData[0].options.filter((field) => field.isRequired).length <= this.data[0].length;
  }

  onImportContact() {
    // CALL ON FINAL IMPORT  
    const newArr = [];
    this.mappingTableData.forEach((el, index) => {
      if (el.colId) {
        if (index === 0) {
          el.data.forEach((ele) => {
            const obj = {};
            obj[el.option.title] = ele;
            newArr.push(obj)
          })
        } else {
          el.data.forEach((ele, i) => {
            const obj = {};
            obj[el.option.title] = ele;
            newArr[i] = { ...obj, ...newArr[i] }
          })
        }
      }
    });
    console.log("this is new newArr", newArr);
    this._matDialogRef.close(newArr);
    // CALLING API AND SUBMIT DATAS
  }

  validateSheetData(data: any[][]): string[] {
    const errors: string[] = [];
    // Skip header row (index 0)
    for (let i = 1; i < data.length; i++) {
      const row = data[i];
      // Name
      if (!row[0] || typeof row[0] !== 'string') {
        errors.push(`Row ${i + 1}: Name is required and must be a string.`);
      }
      // Country Code
      if (!row[1] || (typeof row[1] !== 'string' && typeof row[1] !== 'number')) {
        errors.push(`Row ${i + 1}: Country Code is required and must be vaild.`);
      }
      // Mobile Number
      if (!row[2] || isNaN(Number(row[2])) || String(row[2]).length < 7) {
        errors.push(`Row ${i + 1}: Mobile Number is required and must be valid.`);
      }
      // Package Contents
      if (!row[3] || typeof row[3] !== 'string') {
        errors.push(`Row ${i + 1}: Package Contents must be vaild.`);
      }
      // Package Size (kg)
      if (!row[4] || typeof row[3] !== 'string') {
        errors.push(`Row ${i + 1}: Package Size (kg) must be vaild.`);
      }
      // Cash Collection (optional)
      if (row[5] && isNaN(Number(row[5]))) {
        errors.push(`Row ${i + 1}: Cash Collection must be a number if provided.`);
      }
      // Drop-off Location
      if (!row[6] || typeof row[6] !== 'string') {
        errors.push(`Row ${i + 1}: Drop-off Location must be vaild .`);
      }
    }
    return errors;
  }
}
